import { useState, useEffect, useRef } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CardMedia,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseProduct } from "./UseProduct";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import {
  rsGotoLast,
  rsProgress,
  rsParentChilds,
  rsActiveMenu,
} from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { useSnackbar } from "notistack";
import { Link } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function Product() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();

  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [open, setOpen] = useState({
    productId: "",
    show: false,
    type: undefined,
  });
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { getProducList, deleteProduct, CloneProduct, ResetCache } =
    UseProduct();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [productRes, setProductRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const searchRef = useRef("");

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    setParentID({
      id: null,
      name: "",
    });
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getProducList(
      myPc,
      search,
      (products) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(products.pageCondition.totalPage);
          return;
        }
        setProductRes(products);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/products/addproduct", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 250,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "brandEnName",
      headerName: "برند",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl" }}
          >
            {cellValues.row.brandEnName}
          </Typography>
        );
      },
    },
    {
      field: "productCategoryFaName",
      headerName: "دسته",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productCategoryFaName}
          </Typography>
        );
      },
    },
    {
      field: "hasMetaDescription",
      headerName: "متا",
      width: 75,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.hasMetaDescription ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "isSuspended",
      headerName: "انتشار",
      width: 75,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isSuspend ? (
              <CloseOutlinedIcon style={{ color: "red" }} />
            ) : (
              <CheckIcon style={{ color: "#618833" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 200,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.faName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate(
                    `/products/editproduct?id=${cellValues.row.id} `,
                    {
                      state: {
                        model: cellValues.row,
                        myPc: myPc,
                        search: search,
                        id: cellValues.row.id,
                      },
                    }
                  );
                }}
              >
                <CardMedia
                  sx={{ width: "16px" }}
                  component="img"
                  image="/static/img/EditPen.svg"
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <Link
                target="_blank"
                to={{
                  pathname: `/products/editproduct?id=${cellValues.row.id}`,
                }}
              >
                <IconButton sx={{}}>
                  <CardMedia
                    sx={{ width: "20px" }}
                    component="img"
                    image="/static/img/EditLinki.svg"
                  />
                </IconButton>
              </Link>
            </Tooltip>
            <Tooltip title="ایجاد مجدد">
              <IconButton
                onClick={() =>
                  setOpen({ productId: cellValues.row.id, show: true })
                }
              >
                <FileCopyIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="کش">
              <IconButton
                onClick={() => {
                  setProgress(true);
                  ResetCache(cellValues.row.id, () => {
                    setProgress(false);
                  });
                }}
              >
                <RefreshIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            fullWidth
            defaultValue=""
            onInput={(e) => {
              if (e.target.value == "") {
                handleSearch("");
              }
              searchRef.current = e.target.value;
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(searchRef.current);
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/products" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={open.show}
        onClose={() => setOpen({ ...open, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            برای ایجاد مجدد محصول نوع آن را مشخص و سپس ثبت کنید .
          </DialogContentText>
          <RadioGroup
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            // value={SMSState.allUser}
            sx={{ my: 2 }}
            onChange={(event) => {
              setOpen({ ...open, type: event.target.value });
            }}
          >
            <FormControlLabel
              value={1}
              control={<Radio />}
              label="محصول مشابه"
            />
            <FormControlLabel
              value={2}
              control={<Radio />}
              label="محصول اسلیو"
            />
          </RadioGroup>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={() => {
                let model = {
                  productID: open.productId,
                  type: open.type,
                };
                if (!open.type) {
                  enqueueSnackbar("نوع ایجاد محصول را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                setProgress(true);
                CloneProduct(model, () => {
                  setMsGotoLast(true);
                  setOpen({
                    show: false,
                    type: undefined,
                    productId: undefined,
                  });
                  refresh();
                });
              }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpen({ ...open, show: false })}
            >
              انصراف
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      {productRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={productRes.pageCondition.pageCount}
          rows={productRes.products}
          paginationMode="server"
          page={productRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            productRes?.pageCondition.totalItemCount
              ? productRes.pageCondition.totalItemCount
              : ""
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"محصول"}
        callback={() => {
          setProgress(true);
          deleteProduct(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
